<template>
<v-autocomplete
  v-model="select"
  :items="items"
  :loading="loading"
  :search-input.sync="search"
  hide-no-data
  no-filter
  return-object

  :menu-props="{ offsetY: true, fixed: true }"
  :label="$t('Standort')"
  :placeholder="placeholder"

  no-data-text="Keine passenden Orte gefunden"
  attach
  @change="change"
  filled

  clearable
></v-autocomplete>
</template>

<script>
import { GeocoderFactory } from "./Geocoder";

const DEBOUNCE_MS = 250;

export default {
  name: "GeocoderAutocomplete",

  props: [
    "value",
    "placeholder"
  ],

  data() {
    return {
      loading: false,
      search: null,
      select: null,
      items: []
    };
  },

  created() {
    // je Komponenteninstanz: eigener Timer, eigene Anfragezählung, eigener Geocoder
    this.timer = null;
    this.requestId = 0;
    this.destroyed = false;
    this.geocoder = null;
    this.geocoderReady = GeocoderFactory().then(geocoder => {
      this.geocoder = geocoder;
      return geocoder;
    });
  },

  beforeDestroy() {
    this.destroyed = true;
    this.invalidate();
  },

  watch: {
    search(val) {
      if (!val || !String(val).trim()) {
        this.invalidate();
        this.items = this.select ? [this.select] : [];
        return;
      }

      // Auswahl (Objekt) bzw. vom Elternteil zurückgeschriebener Text löst keine Suche aus
      const selectedText = this.select && typeof this.select === "object" ? this.select.text : this.select;
      if (selectedText && val === selectedText) {
        return;
      }

      this.querySelections(val);
    },

    value(val) {
      if (val) {
        this.select = val;
      }
    }
  },

  methods: {
    // beendet Timer und laufende Anfrage; verspätete Antworten werden ignoriert
    invalidate() {
      this.requestId++;

      if (this.timer != null) {
        clearTimeout(this.timer);
        this.timer = null;
      }

      if (this.geocoder) {
        this.geocoder.cancelAutocomplete();
      }

      this.loading = false;
    },

    querySelections(value) {
      this.invalidate();

      const id = this.requestId;
      this.loading = true;

      this.timer = setTimeout(() => {
        this.timer = null;

        this.geocoderReady.then(geocoder => {
          if (id !== this.requestId || this.destroyed) {
            return null;
          }

          return geocoder.autocomplete(value);
        }).then(items => {
          if (id !== this.requestId || this.destroyed || items === null) {
            return;
          }

          this.items = items;
        }, () => {
          if (id !== this.requestId || this.destroyed) {
            return;
          }

          this.items = [];
        }).then(() => {
          if (id === this.requestId && !this.destroyed) {
            this.loading = false;
          }
        });
      }, DEBOUNCE_MS);
    },

    change(o) {
      this.invalidate();
      this.items = o ? [o] : [];
      this.$emit("change", o);
    }
  }
};
</script>
